export default __webpack_public_path__ + "static/media/151-fireplace-1.33f40b24.png";